export class CloudProviderCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "cloudProviders",
            "baseName": "cloudProviders",
            "type": "Array<Provider>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudProviderCondition.attributeTypeMap;
    }
    constructor() {
    }
}
